/**
 * Reports whether the page has scrolled past 100px.
 *
 * Ported from `public/index.html:693-707`, which toggled `scrolled` on the
 * header element.
 */
import { useEffect, useState } from 'react';

export const useStickyHeader = (): boolean => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset > 100);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return scrolled;
};
